var exports = {
  "MY": "OAuthAuthorizePage.module__page___N3c2ZC",
  "g4": "OAuthAuthorizePage.module__loadingContainer___N3c2ZC",
  "Un": "OAuthAuthorizePage.module__errorContainer___N3c2ZC",
  "ow": "OAuthAuthorizePage.module__errorContent___N3c2ZC",
  "JU": "OAuthAuthorizePage.module__errorTitle___N3c2ZC",
  "kc": "OAuthAuthorizePage.module__errorText___N3c2ZC",
  "d1": "OAuthAuthorizePage.module__heroCard___N3c2ZC",
  "iC": "OAuthAuthorizePage.module__heroCopy___N3c2ZC",
  "ZY": "OAuthAuthorizePage.module__heroTitle___N3c2ZC",
  "fd": "OAuthAuthorizePage.module__heroDescription___N3c2ZC",
  "$2": "OAuthAuthorizePage.module__cardGrid___N3c2ZC",
  "Ql": "OAuthAuthorizePage.module__accountList___N3c2ZC",
  "ts": "OAuthAuthorizePage.module__sectionDivider___N3c2ZC",
  "nd": "OAuthAuthorizePage.module__panel___N3c2ZC",
  "bV": "OAuthAuthorizePage.module__sectionHeader___N3c2ZC",
  "Gf": "OAuthAuthorizePage.module__sectionTitle___N3c2ZC",
  "yV": "OAuthAuthorizePage.module__sectionDescription___N3c2ZC",
  "s0": "OAuthAuthorizePage.module__inlineStatus___N3c2ZC",
  "Jb": "OAuthAuthorizePage.module__scopeList___N3c2ZC",
  "_9": "OAuthAuthorizePage.module__permissionScrollContainer___N3c2ZC",
  "C6": "OAuthAuthorizePage.module__permissionScroller___N3c2ZC",
  "Mg": "OAuthAuthorizePage.module__permissionList___N3c2ZC",
  "ce": "OAuthAuthorizePage.module__permissionRow___N3c2ZC",
  "Ck": "OAuthAuthorizePage.module__permissionLabel___N3c2ZC",
  "rJ": "OAuthAuthorizePage.module__scopeRow___N3c2ZC",
  "BB": "OAuthAuthorizePage.module__scopeHeading___N3c2ZC",
  "OK": "OAuthAuthorizePage.module__scopeName___N3c2ZC",
  "RJ": "OAuthAuthorizePage.module__scopeDescription___N3c2ZC",
  "Pp": "OAuthAuthorizePage.module__scopeChip___N3c2ZC",
  "p$": "OAuthAuthorizePage.module__emptyState___N3c2ZC",
  "uL": "OAuthAuthorizePage.module__caution___N3c2ZC",
  "iB": "OAuthAuthorizePage.module__dangerNotice___N3c2ZC",
  "mW": "OAuthAuthorizePage.module__successScreen___N3c2ZC",
  "n7": "OAuthAuthorizePage.module__successIconCircle___N3c2ZC",
  "FU": "OAuthAuthorizePage.module__successIcon___N3c2ZC",
  "QK": "OAuthAuthorizePage.module__successTitle___N3c2ZC",
  "s3": "OAuthAuthorizePage.module__successSubtitle___N3c2ZC",
  "cs": "OAuthAuthorizePage.module__successAction___N3c2ZC",
  "By": "OAuthAuthorizePage.module__guildOption___N3c2ZC",
  "rZ": "OAuthAuthorizePage.module__guildValue___N3c2ZC",
  "XN": "OAuthAuthorizePage.module__guildAvatar___N3c2ZC",
  "oM": "OAuthAuthorizePage.module__guildAvatarPlaceholder___N3c2ZC",
  "p2": "OAuthAuthorizePage.module__guildOptionLabel___N3c2ZC",
  "RG": "OAuthAuthorizePage.module__guildOptionDisabled___N3c2ZC",
  "p4": "OAuthAuthorizePage.module__guildOptionNotice___N3c2ZC",
  "A2": "OAuthAuthorizePage.module__actionSection___N3c2ZC",
  "PJ": "OAuthAuthorizePage.module__footerText___N3c2ZC",
  "o1": "OAuthAuthorizePage.module__actions___N3c2ZC",
  "hP": "OAuthAuthorizePage.module__actionButton___N3c2ZC",
};

module.exports = exports;
